import React from 'react';
import { Link } from 'react-router';
import Sticky from 'react-sticky-el';

class SupportNav extends React.Component {
	handleClick(e) {
		global.dataLayer.push({
			event: 'Sub Nav',
			eventCategory: 'Sub Navigation',
			eventAction: global.location.pathname,
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		return (
			<Sticky className="page-nav">
				<div className="row">
					<div className="col">
						<ul>
							<li>
								<Link
									to="/support/find-your-model-or-serial-number"
									onClick={ e => this.handleClick(e) }
								>
									Find Model/Serial Number
								</Link>
							</li>
							<li>
								<Link
									to="/support/faqs"
									onClick={ e => this.handleClick(e) }
								>
									FAQs
								</Link>
							</li>
							<li>
								<Link
									to="/support/lost-key-combo"
									onClick={ e => this.handleClick(e) }
								>
									Lost Key or Combo
								</Link>
							</li>
							<li>
								<Link
									to="/support/videos"
									onClick={ e => this.handleClick(e) }
								>
									Videos
								</Link>
							</li>
							<li>
								<Link
									to="/support/product-manuals"
									onClick={ e => this.handleClick(e) }
								>
									Product Manuals
								</Link>
							</li>
							<li>
								<Link
									to="/support/contact-us"
									onClick={ e => this.handleClick(e) }
								>
									Contact Us
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</Sticky>
		);
	}
}

export default SupportNav;


// WEBPACK FOOTER //
// ./src/pages/support/SupportNav.js